/**
 * @generated SignedSource<<17e97e2c443d9f26d4dbb785024781fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateDiningBookingHoldInput = {
  accessPersistentId: string;
  date: string;
  facilityId: string;
  ownerId: string;
  partySize: number;
  policy?: string | null | undefined;
  roomName?: string | null | undefined;
  shiftPersistentId: string;
  time: string;
};
export type useCreateReservationHoldMutation$variables = {
  input: CreateDiningBookingHoldInput;
};
export type useCreateReservationHoldMutation$data = {
  readonly createDiningBookingHold: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly reservationHoldId: string;
    readonly success: boolean;
  } | null | undefined;
};
export type useCreateReservationHoldMutation = {
  response: useCreateReservationHoldMutation$data;
  variables: useCreateReservationHoldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reservationHoldId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCreateReservationHoldMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateDiningBookingHoldPayload",
        "kind": "LinkedField",
        "name": "createDiningBookingHold",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreateReservationHoldMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateDiningBookingHoldPayload",
        "kind": "LinkedField",
        "name": "createDiningBookingHold",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b77c35c9b4338b86e63fbcbd922ba29c",
    "id": null,
    "metadata": {},
    "name": "useCreateReservationHoldMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateReservationHoldMutation(\n  $input: CreateDiningBookingHoldInput!\n) {\n  createDiningBookingHold(input: $input) {\n    reservationHoldId\n    success\n    errors {\n      __typename\n      code\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0fb5664101eb7e5747f4f75d77ebe8a8";

export default node;
